export default function ($http) {
    return function (task) {
        return $http.put(`api/tasks/${task.id}/takeOwnership`);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/tasks/takeTaskOwnership.js